import { render, staticRenderFns } from "./IconBattery.vue?vue&type=template&id=bcf032fc&"
import script from "./IconBattery.vue?vue&type=script&lang=js&"
export * from "./IconBattery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports